/**
 * Typed text placed in a CKEditor-backed field, escaped as the editor escapes text (`&`, `<`, `>`; quotes only
 * in attributes) so the stored words match its output.
 */
export function textToHtml(text: string | null | undefined): string {
  return String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
